<template>
  <div class="gmap-wrapper">
    <div class="pac-card" id="pac-card" v-if="autocomplete">
      <div id="pac-container">
        <input id="pac-input" type="text" placeholder="Enter a location" />
      </div>
    </div>
    <div id="map"></div>
  </div>
</template>

<script>
export default {
  props: ["autocomplete"],
};
</script>



// WEBPACK FOOTER //
// src/components/shared/MapModal.vue